export enum LegalProtectionVariant {
    BASIC = "BASIC",
    COMPLETE = "COMPLETE"
}

export interface LegalProtectionVariantModel {
    value: LegalProtectionVariant;
    label: string;
    sumLabel: string;
}

export const LegalProtectionVariants: LegalProtectionVariantModel[] = [
    {
        value: LegalProtectionVariant.BASIC,
        label: "Podstawowa",
        sumLabel: "2 000 zł"
    },
    {
        value: LegalProtectionVariant.COMPLETE,
        label: "Pełna",
        sumLabel: "10 000 zł"
    }
];